import { Grid } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DrawIcon from '@mui/icons-material/Draw';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PaidIcon from '@mui/icons-material/Paid';
import BuildIcon from '@mui/icons-material/Build';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import StatCard from './StatCard';
import { formatMoney } from '../utils';

const SummaryCards = ({ summary, totalRevenue, totalEquipment, totalPaid, paidEquipment, netEarnings, conversionRate, collectionRate }) => (
  <>
    <Grid container spacing={2} sx={{ mb: 2 }}>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard title="Total Contracts" value={summary?.total || 0} icon={<DescriptionIcon sx={{ color: '#0d3c61', fontSize: 28 }} />} color="#0d3c61" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard title="Viewed by Client" value={summary?.viewedByClient || 0} icon={<VisibilityIcon sx={{ color: '#ff9800', fontSize: 28 }} />} color="#ff9800" subtitle={summary?.total ? `${((summary.viewedByClient / summary.total) * 100).toFixed(0)}% of total` : ''} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard title="Signed" value={summary?.signed || 0} icon={<DrawIcon sx={{ color: '#4caf50', fontSize: 28 }} />} color="#4caf50" subtitle={`${conversionRate}% conversion`} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard title="Contract Value" value={formatMoney(totalRevenue)} icon={<AttachMoneyIcon sx={{ color: '#1976d2', fontSize: 28 }} />} color="#1976d2" />
      </Grid>
    </Grid>

    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard title="Equipment" value={formatMoney(totalEquipment)} icon={<BuildIcon sx={{ color: '#7b1fa2', fontSize: 28 }} />} color="#7b1fa2" subtitle={totalRevenue > 0 ? `${((totalEquipment / totalRevenue) * 100).toFixed(0)}% of value` : ''} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard title="Paid by Clients" value={formatMoney(totalPaid)} icon={<PaidIcon sx={{ color: '#2e7d32', fontSize: 28 }} />} color="#2e7d32" subtitle={`${collectionRate}% collected`} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard title="Paid minus Equipment" value={formatMoney(netEarnings)} icon={<TrendingUpIcon sx={{ color: '#00695c', fontSize: 28 }} />} color="#00695c" subtitle={totalPaid > 0 ? `Equipment: ${formatMoney(paidEquipment)}` : ''} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard title="Outstanding" value={formatMoney(totalRevenue - totalPaid)} icon={<AttachMoneyIcon sx={{ color: '#e65100', fontSize: 28 }} />} color="#e65100" subtitle={totalRevenue > 0 ? `${(100 - Number(collectionRate)).toFixed(0)}% remaining` : ''} />
      </Grid>
    </Grid>
  </>
);

export default SummaryCards;
